import React from "react";
import { cn } from "@/lib/utils"; // 確保此路徑正確
// 假設你有使用自定義 hook
// import { useRevealOnScroll } from "@/hooks/use-reveal-on-scroll"; 

const advantages = [{
  icon: "https://hent.services/wp-content/uploads/2026/05/Support.webp",
  titleZh: "專業施工配合",
  titleEn: "Professional Installation Support",
  descZh: "美感兼顧，安心省心",
  descEn: "Support"
}, {
  icon: "https://hent.services/wp-content/uploads/2026/05/Selection.webp",
  titleZh: "協助挑色",
  titleEn: "Expert Color Selection",
  descZh: "親民貼心，選色不煩惱",
  descEn: "Selection"
}, {
  icon: "https://hent.services/wp-content/uploads/2026/05/Natural.webp",
  titleZh: "自然光展示",
  titleEn: "Natural Light Display",
  descZh: "貼近自然光，白天最真實",
  descEn: "Natural"
}, {
  icon: "https://hent.services/wp-content/uploads/2026/05/Versatile.webp",
  titleZh: "平鋪 x 斜拚 x 樓梯施工",
  titleEn: "Versatile Layouts & Staircase Installation",
  descZh: "施工多樣化，美觀又耐用",
  descEn: "Versatile"
}];
export default function OurAdvantages() {
  // 這裡假設 isSectionVisible 暫時為 true，如果你有 hook 請換回
  const isSectionVisible = true;
  const sectionRef = React.useRef(null);
  return <section id="品牌核心優勢" className="bg-background py-8 md:py-20 overflow-hidden" ref={sectionRef}>
  <div className="container mx-auto px-6 md:px-12 py-12 md:py-16 md:border md:border-border/40 rounded-sm md:bg-card/10 md:shadow-sm">
    
    {/* 標題區：字體顏色同步優化為 #3d3d3d */}
    <div className={cn("mb-12 md:mb-24 text-center transition-all duration-1000 ease-out", isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="relative mb-3 w-fit mx-auto">
        <h2 className="text-[1.15rem] sm:text-2xl md:text-4xl font-hk-regular tracking-tight relative z-10 px-1 whitespace-nowrap text-[#3d3d3d]">
          從挑選到施工 | 我們都幫你想好
        </h2>
        {/* 標題底色塊 */}
        <div className="absolute left-0 bottom-1 w-full h-3 bg-[#D9C5B2]/80 -z-10" />
      </div>
      <p className="text-[10px] md:text-sm font-sans font-medium tracking-[0.2em] uppercase text-[#3d3d3d]/60">
        Our Advantages
      </p>
    </div>

    {/* 網格區：全尺寸置中 */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16 lg:gap-[80px]">
      {advantages.map((adv, i) => <div key={i} className={cn("group flex flex-col items-center text-center transition-all duration-1000 ease-out", isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
          {/* Icon 容器：背景透明、Icon 放大 */}
          <div className="size-20 md:size-24 flex items-center justify-center overflow-hidden transition-all duration-500 mb-1">
            <img src={adv.icon} alt={adv.titleZh} className="w-[85%] h-[85%] object-contain transition-all duration-500 group-hover:scale-110" />
          </div>
          
          {/* 優勢標題：字體顏色 #3d3d3d */}
          <div className="mb-1">
            <h3 className="text-lg md:text-xl font-bold tracking-wide mb-1 font-tc-semibold !text-[#7c6250]">
              {adv.titleZh}
            </h3>
            {/* <p className="text-[10px] font-sans font-medium tracking-widest uppercase !text-[#7c6250]/60">
              {adv.titleEn}
             </p> */}
          </div>

          {/* 優勢描述：字體顏色 #7c6250 (暖木棕) */}
          <div className="space-y-1 px-4 md:px-0">
            <p className="text-sm md:text-base leading-relaxed font-hk-light text-[#7c6250]">
              {adv.descZh}
            </p>
            {/* 電腦版英文描述 */}
            <p className="text-[11px] leading-relaxed font-sans italic hidden md:block text-[#7c6250]/70">
              {adv.descEn}
            </p>
          </div>
        </div>)}
    </div>
  </div>
</section>;
}